import React from 'react';
import { Spinner, Table } from 'react-bootstrap';
import { PaginationType, emptyPagination, useServiceSubscribe } from '~/util';
import { Pagination } from '~/components/Pagination';
import { useAdminService } from '~/services';
import { ReportRow } from '~/components/Admin';

export interface ReportType {
    id: number;
    type: number;
    status: number;
    filters: {
        summary: string[];
        to?: string;
        from?: string;
        patient_gmpis?: number[]; // eslint-disable-line babel/camelcase
        markets?: number[];
        provider_id?: number; // eslint-disable-line babel/camelcase
        user_id?: number; // eslint-disable-line babel/camelcase
    };
    created_at: string; // eslint-disable-line babel/camelcase
    updated_at: string; // eslint-disable-line babel/camelcase
    media: MediaFileType;
}

export function ListReports() {
    const { getReports, events } = useAdminService();
    const [loading, setLoading] = React.useState(false);
    const [list, setList] = React.useState<ReportType[]>([]);
    const paginationRef = React.useRef(emptyPagination());

    const loadReports = React.useCallback(async () => {
        setLoading(true);
        const { results, pagination } = await getReports({
            page: paginationRef.current.current,
            items_per_page: paginationRef.current.items_per_page,
        });
        setList(results);
        paginationRef.current = pagination;
        setLoading(false);
    }, [getReports]);

    React.useEffect(() => {
        loadReports();
    }, [loadReports]);
    useServiceSubscribe(events.report_list_updated, loadReports);

    function updatePagination(pagination: PaginationType) {
        paginationRef.current = { ...pagination };
        loadReports();
    }

    return (
        <>
            <div className="table-scroll">
                <Table striped bordered hover className="fixed-table">
                    <thead className="table-dark">
                        <tr>
                            <th className="th-9 th-sm-5">Report Type</th>
                            <th>Report Filters</th>
                            <th className="th-9 th-sm-6">Requested Date</th>
                            <th className="th-3">
                                <span className="sr-only">Actions</span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading && (
                            <tr>
                                <td colSpan={4} className="text-center bg-white">
                                    <Spinner animation="border">
                                        <span className="sr-only">Loading Reports</span>
                                    </Spinner>
                                </td>
                            </tr>
                        )}
                        {list.map((report: ReportType) => (
                            <ReportRow report={report} key={report.id} />
                        ))}
                    </tbody>
                </Table>
            </div>
            <Pagination pagination={paginationRef.current} updatePagination={updatePagination} />
        </>
    );
}
